import axios from 'axios';
import { setUrlRiesgoNet, enableRiesgoNet } from '../../../actions/actions';
import { store } from '../../../store/configure';

export const storeUrlRiesgoNet = (history) => {
    return new Promise((resolve, reject) => {
        getUrlRiesgoNet().then((response) => {
            store.dispatch(
                setUrlRiesgoNet(response.data)
            );
            store.dispatch(
                enableRiesgoNet()
            );
            resolve({
                message: response.message,
                data: response.data
            })
        }).catch((error) => {
            store.dispatch(
                setUrlRiesgoNet('NO_DEFINIDA'),
            );
            history.push('/error');
            reject({
                mensaje: error.message
            })
        });
    })
}

const getUrlRiesgoNet = () => {
    return new Promise((resolve, reject) => {
        axios.get( localStorage.getItem('url') + '/api/vu/getUrlRiesgoNet').then(response => {
            resolve({
                message: "URL de RiesgoNet establecida de manera satisfactoria.",
                data: response.data
            })
        }).catch(() => {
            reject({
                message: "Ocurrio un error al obtener la URL de RiesgoNet.",
            })
        })
    })
}


// WEBPACK FOOTER //
// ./src/components/OnBoarding/services/riesgoNetService.js